import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export default function ReassignDialog({ open, onOpenChange, agents, onConfirm, count, kind = "leads" }) {
  const [agentId, setAgentId] = useState("");

  const agent = agents.find((a) => a.id === agentId);
  const message = kind === "activities"
    ? `You are about to reassign ${count} activities to ${agent?.name || "[Agent]"}. Related leads and their full activity histories will also be reassigned to keep ownership consistent. Continue?`
    : `You are about to reassign ${count} leads to ${agent?.name || "[Agent]"}. All related activities, including historical completed activities, will also be reassigned to the new agent. Continue?`;

  const submit = () => {
    if (!agentId) return;
    onConfirm(agentId);
    setAgentId("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="reassign-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display">Reassign {kind}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-xs font-medium uppercase tracking-wider text-gray-500 mb-1.5 block">
              Assign to
            </label>
            <Select value={agentId} onValueChange={setAgentId}>
              <SelectTrigger data-testid="reassign-agent-select">
                <SelectValue placeholder="Select an agent" />
              </SelectTrigger>
              <SelectContent>
                {agents.filter((a) => a.role === "agent" && a.is_active !== false).map((a) => (
                  <SelectItem key={a.id} value={a.id}>{a.name} — {a.email}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          {agentId && (
            <p className="text-sm text-gray-700 leading-relaxed bg-yellow-50 border border-yellow-200 rounded-md p-3">
              {message}
            </p>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button
            onClick={submit}
            disabled={!agentId}
            data-testid="reassign-confirm"
            className="bg-[#1A3A21] hover:bg-[#142C19] text-white"
          >
            Reassign
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
